import React, { useState } from 'react';
import { X } from 'lucide-react';
import { salonInfo } from '../data/mock';

const WhatsAppButton = () => {
  const [isHovered, setIsHovered] = useState(false);

  // Placeholder WhatsApp number - will be updated when client provides
  const whatsappNumber = salonInfo.whatsapp || '+15551234567';
  const message = encodeURIComponent(`Hi! I'd like to inquire about booking an appointment at ${salonInfo.name}.`);
  const whatsappUrl = `https://wa.me/${whatsappNumber.replace(/[^0-9]/g, '')}?text=${message}`;

  return (
    <div className="fixed bottom-24 right-6 z-50">
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className="group relative flex items-center justify-center w-16 h-16 bg-[#25D366] rounded-full shadow-2xl hover:shadow-green-500/50 transition-all duration-300 hover:scale-110"
      >
        {/* Official WhatsApp Logo SVG */}
        <svg 
          viewBox="0 0 32 32" 
          className="w-9 h-9"
          fill="white"
        >
          <path d="M16 0C7.163 0 0 7.163 0 16c0 2.825.737 5.482 2.025 7.788L.075 30.925l7.337-1.925C9.682 30.263 12.738 31 16 31c8.837 0 16-7.163 16-16S24.837 0 16 0zm0 29.5c-2.537 0-4.95-.637-7.05-1.788l-.5-.287-5.2 1.363 1.388-5.075-.3-.525C3.075 21.063 2.5 18.588 2.5 16c0-7.45 6.05-13.5 13.5-13.5s13.5 6.05 13.5 13.5-6.05 13.5-13.5 13.5z"/>
          <path d="M23.363 19.45c-.388-.188-2.288-1.125-2.638-1.25s-.613-.188-.875.188-.988 1.25-1.213 1.5-.45.275-.838.087c-.387-.187-1.637-.6-3.112-1.912-1.15-1.025-1.925-2.287-2.15-2.675s-.025-.575.162-.762c.175-.175.388-.45.575-.675.188-.225.25-.375.375-.625s.063-.475-.037-.675-.875-2.1-1.2-2.875c-.312-.762-.625-.65-.875-.662l-.75-.012c-.25 0-.662.1-1.013.475s-1.325 1.3-1.325 3.175 1.363 3.675 1.55 3.925 2.65 4.05 6.425 5.675c.9.387 1.6.625 2.15.8.9.287 1.725.25 2.375.15.725-.112 2.288-.937 2.613-1.837s.325-1.688.225-1.838-.337-.25-.725-.437z"/>
        </svg>
        
        {/* Tooltip */}
        {isHovered && (
          <div className="absolute right-full mr-4 px-4 py-2 bg-gray-900 text-white text-sm rounded-lg whitespace-nowrap shadow-xl">
            Chat with us on WhatsApp
            <div className="absolute top-1/2 -right-1 transform -translate-y-1/2 w-2 h-2 bg-gray-900 rotate-45"></div>
          </div>
        )}
      </a>
    </div>
  );
};

export default WhatsAppButton;
